import { LeftOutlined } from "@ant-design/icons";
import { Button, Col, Row, Typography } from "antd";
import React from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { removeProperty, removeUuid } from "service/auth";
import styled from "styled-components";
import tw from "twin.macro";
import SiderMenuItem, { SiderMenuItemProps } from "./item";

export interface SiderMenuProps {
  menus: SiderMenuItemProps[];
  isPropertyPath: boolean;
}

const SiderMenuWrapper = styled.div<{ $isPropertyPath: boolean }>`
  ${({ $isPropertyPath }) => ($isPropertyPath ? tw`pb-5 pt-14` : "pb-10")};
  height: 100%;
  overflow-y: auto;
`;

const GobackWrapper = styled.div`
  ${tw`absolute bg-gray p-4`};
  z-index: 2;
  top: 0px;
  left: 0px;
  right: 0px;
  svg * {
    color: white;
  }
`;

const SiderMenu: React.FC<SiderMenuProps> = ({ menus, isPropertyPath }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <div className="relative" style={{ height: "calc(100vh - 71px)" }}>
      {isPropertyPath ? (
        <GobackWrapper className="flex items-center">
          <Button
            className="center"
            onClick={() => {
              removeUuid();
              removeProperty();
              navigate("/property", { replace: true });
            }}
            style={{
              width: 20,
              height: 20,
              backgroundColor: "#F8931D",
              borderColor: "#F8931D",
            }}
            icon={<LeftOutlined style={{ fontSize: 9 }} />}
          />
          <Typography.Text className="ml-2">{t("back")}</Typography.Text>
        </GobackWrapper>
      ) : null}
      <SiderMenuWrapper $isPropertyPath={isPropertyPath}>
        <Row>
          <Col span={24}>
            {menus.map((item) => {
              return <SiderMenuItem item={item} key={item.key} />;
            })}
          </Col>
        </Row>
      </SiderMenuWrapper>
    </div>
  );
};

export default SiderMenu;
